import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/football_worldcups_logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "videogame-trailers.com",
  src: _imports_0,
  class: "logo responsive-logo",
  width: "693",
  height: "60"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, {
    fluid: "",
    class: "header-panel"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_b_row, {
        class: "background-repeat bg-color",
        style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage})` })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { lg: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_link, { href: "/" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}